import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { id: "mobile_filled" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.452 9.981h1.092v3.571H4.452V9.981Zm2.039-1.529h1.02v5.1h-1.02v-5.1Zm2.039 2.913h1.022v2.187H8.53v-2.187Z",
    class: "cls-1",
    transform: "translate(-2.5 -1.5)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 .01 2 0a2.006 2.006 0 0 0-2 2v18a2.006 2.006 0 0 0 2 2h10a2.006 2.006 0 0 0 2-2V2a2 2 0 0 0-2-1.99ZM12 18H2V4h10v14Z",
    class: "cls-1",
    transform: "translate(-2.5 -1.5)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };